import { useState } from "react";
import { navigateToUrl } from "single-spa";

const VENDOR_FIT_PRIORITIES_STORAGE_KEY_PREFIX = "vendorFitPriorities";

export const useCreateInitiative = () => {
  const [isLoadingInitiative, setIsLoadingInitiative] = useState(false);

  const createInitiative = async (templateId: number) => {
    const prioritiesStorageKey = `${VENDOR_FIT_PRIORITIES_STORAGE_KEY_PREFIX}-${templateId}`;
    const weightedPriorities = JSON.parse(sessionStorage.getItem(prioritiesStorageKey) || "[]");
    setIsLoadingInitiative(true);
    try {
      const response = await window.fetch(`${window.gxApiConnection}/api/v5/initiatives/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ templateId, weightedPriorities })
      });
      const data = await response.json();
      const initiativeId = data?.data?.initiativeId || "";
      if (!response.ok || !initiativeId) {
        throw new Error("Failed to create initiative");
      }
      await window.eventBus.publish("USER_STATE_LOAD");
      sessionStorage.removeItem(prioritiesStorageKey);
      navigateToUrl(`/s/evaluation/${initiativeId}/overview`);
    } finally {
      setIsLoadingInitiative(false);
    }
  };

  return { createInitiative, isLoadingInitiative };
};
